module.exports = __webpack_public_path__ + "img/DSC_1124.39020f90.jpg";